import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainHeader from './header/MainHeader';
import Footer from './footer/Footer';
import './support.css';

function Support() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('faq');
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  const faqs = [
    {
      category: t('support.faq_cat_getting_started'),
      questions: [
        {
          question: t('support.faq_q1_1'),
          answer: t('support.faq_a1_1'),
        },
        {
          question: t('support.faq_q1_2'),
          answer: t('support.faq_a1_2'),
        },
        {
          question: t('support.faq_q1_3'),
          answer: t('support.faq_a1_3'),
        },
      ],
    },
    {
      category: t('support.faq_cat_buying'),
      questions: [
        {
          question: t('support.faq_q2_1'),
          answer: t('support.faq_a2_1'),
        },
        {
          question: t('support.faq_q2_2'),
          answer: t('support.faq_a2_2'),
        },
        {
          question: t('support.faq_q2_3'),
          answer: t('support.faq_a2_3'),
        },
        {
          question: t('support.faq_q2_4'),
          answer: t('support.faq_a2_4'),
        },
      ],
    },
    {
      category: t('support.faq_cat_selling'),
      questions: [
        {
          question: t('support.faq_q3_1'),
          answer: t('support.faq_a3_1'),
        },
        {
          question: t('support.faq_q3_2'),
          answer: t('support.faq_a3_2'),
        },
        {
          question: t('support.faq_q3_3'),
          answer: t('support.faq_a3_3'),
        },
        {
          question: t('support.faq_q3_4'),
          answer: t('support.faq_a3_4'),
        },
      ],
    },
    {
      category: t('support.faq_cat_safety'),
      questions: [
        {
          question: t('support.faq_q4_1'),
          answer: t('support.faq_a4_1'),
        },
        {
          question: t('support.faq_q4_2'),
          answer: t('support.faq_a4_2'),
        },
        {
          question: t('support.faq_q4_3'),
          answer: t('support.faq_a4_3'),
        },
      ],
    },
    {
      category: t('support.faq_cat_account'),
      questions: [
        {
          question: t('support.faq_q5_1'),
          answer: t('support.faq_a5_1'),
        },
        {
          question: t('support.faq_q5_2'),
          answer: t('support.faq_a5_2'),
        },
        {
          question: t('support.faq_q5_3'),
          answer: t('support.faq_a5_3'),
        },
      ],
    },
    {
      category: t('support.faq_cat_dealer'),
      questions: [
        {
          question: t('support.faq_q6_1'),
          answer: t('support.faq_a6_1'),
        },
        {
          question: t('support.faq_q6_2'),
          answer: t('support.faq_a6_2'),
        },
        {
          question: t('support.faq_q6_3'),
          answer: t('support.faq_a6_3'),
        },
      ],
    },
  ];

  return (
    <div>
      <MainHeader />

      {/* Hero Section */}
      <div className="support-hero">
        <div className="container">
          <div className="support-hero-content">
            <h1>{t('support.hero_title')}</h1>
            <p className="support-hero-subtitle">
              {t('support.hero_subtitle')}
            </p>
            <div className="support-search-box">
              <input
                type="text"
                className="form-control support-search-input"
                placeholder={t('support.search_placeholder')}
              />
            </div>
          </div>
        </div>
      </div>

      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-11 mx-auto">
              {/* Quick Contact Cards */}
              <div className="row mb-5">
                <div className="col-md-4 mb-4">
                  <div className="card support-contact-card h-100 shadow-sm border-0">
                    <div className="card-body text-center p-3">
                      <div className="support-icon-wrapper">
                        <i className="fas fa-envelope"></i>
                      </div>
                      <h5 className="card-title">{t('support.email_support')}</h5>
                      <p className="text-muted mb-3 small">
                        {t('support.email_response')}
                      </p>
                      <a
                        href="mailto:support@autoplace.al"
                        className="btn btn-primary btn-sm px-3 py-1"
                        style={{ borderRadius: '50px', fontSize: '0.85rem' }}
                      >
                        support@autoplace.al
                      </a>
                      <span className="support-badge support-badge-success">
                        <i className="fas fa-check-circle mr-1"></i>
                        {t('support.response_24h')}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="card support-contact-card h-100 shadow-sm border-0">
                    <div className="card-body text-center p-3">
                      <div className="support-icon-wrapper">
                        <i className="fas fa-comments"></i>
                      </div>
                      <h5 className="card-title">{t('support.live_chat')}</h5>
                      <p className="text-muted mb-3 small">
                        {t('support.live_chat_desc')}
                      </p>
                      <button
                        className="btn btn-primary btn-sm px-3 py-1"
                        style={{ borderRadius: '50px', fontSize: '0.85rem' }}
                      >
                        <i className="fas fa-comment-dots mr-2"></i>
                        {t('support.start_chat')}
                      </button>
                      <span className="support-badge support-badge-info">
                        <i className="fas fa-clock mr-1"></i>{t('support.chat_hours')}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="card support-contact-card h-100 shadow-sm border-0">
                    <div className="card-body text-center p-3">
                      <div className="support-icon-wrapper">
                        <i className="fas fa-phone-alt"></i>
                      </div>
                      <h5 className="card-title">{t('support.phone_support')}</h5>
                      <p className="text-muted mb-3 small">
                        {t('support.phone_desc')}
                      </p>
                      <a
                        href="tel:+1-800-AUTO-PLC"
                        className="btn btn-primary btn-sm px-3 py-1"
                        style={{ borderRadius: '50px', fontSize: '0.85rem' }}
                      >
                        <i className="fas fa-phone mr-2"></i>
                        1-800-AUTO-PLC
                      </a>
                      <span className="support-badge support-badge-info">
                        <i className="fas fa-calendar-alt mr-1"></i>
                        {t('support.mon_fri')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tab Navigation */}
              <ul className="nav support-tabs" role="tablist">
                <li className="nav-item">
                  <button
                    className={`nav-link support-tab ${activeTab === 'faq' ? 'active' : ''}`}
                    onClick={() => setActiveTab('faq')}
                  >
                    <i className="fas fa-question-circle"></i>
                    {t('support.tab_faq')}
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link support-tab ${activeTab === 'contact' ? 'active' : ''}`}
                    onClick={() => setActiveTab('contact')}
                  >
                    <i className="fas fa-envelope"></i>
                    {t('support.tab_contact')}
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link support-tab ${activeTab === 'resources' ? 'active' : ''}`}
                    onClick={() => setActiveTab('resources')}
                  >
                    <i className="fas fa-book"></i>
                    {t('support.tab_resources')}
                  </button>
                </li>
              </ul>

              {/* FAQ Tab */}
              {activeTab === 'faq' && (
                <div className="tab-content">
                  <div className="text-center mb-5">
                    <h2 className="font-weight-bold mb-3">
                      {t('support.faq_title')}
                    </h2>
                    <p className="text-muted">
                      {t('support.faq_subtitle')}
                    </p>
                  </div>

                  {faqs.map((category, categoryIndex) => (
                    <div key={categoryIndex} className="faq-category">
                      <h4 className="faq-category-title">
                        <div className="faq-category-icon">
                          <i className="fas fa-folder-open"></i>
                        </div>
                        {category.category}
                      </h4>

                      <div className="accordion">
                        {category.questions.map((faq, faqIndex) => {
                          const globalIndex = categoryIndex * 100 + faqIndex;
                          const isExpanded = expandedFaq === globalIndex;
                          return (
                            <div key={faqIndex} className="faq-item">
                              <button
                                className={`faq-question ${isExpanded ? 'active' : ''}`}
                                onClick={() => toggleFaq(globalIndex)}
                              >
                                <span>{faq.question}</span>
                                <i
                                  className={`fas fa-chevron-down faq-chevron`}
                                ></i>
                              </button>
                              {isExpanded && (
                                <div className="faq-answer">
                                  <p className="mb-0">{faq.answer}</p>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Contact Form Tab */}
              {activeTab === 'contact' && (
                <div className="tab-content">
                  <h3 className="font-weight-bold mb-4">{t('support.contact_title')}</h3>
                  <p className="mb-4">
                    {t('support.contact_desc')}
                  </p>

                  <form>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label
                          className="font-weight-bold"
                          style={{ fontSize: '0.85rem' }}
                        >
                          {t('support.full_name')}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t('support.name_placeholder')}
                          required
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="font-weight-bold"
                          style={{ fontSize: '0.85rem' }}
                        >
                          {t('support.email_label')}
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder={t('support.email_placeholder')}
                          required
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label
                          className="font-weight-bold"
                          style={{ fontSize: '0.85rem' }}
                        >
                          {t('support.phone_label')}
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">+355</span>
                          <input
                            type="tel"
                            className="form-control"
                            placeholder={t('support.phone_placeholder')}
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="font-weight-bold"
                          style={{ fontSize: '0.85rem' }}
                        >
                          {t('support.subject_label')}
                        </label>
                        <select className="form-control" required>
                          <option value="">{t('support.subject_placeholder')}</option>
                          <option value="account">{t('support.subject_account')}</option>
                          <option value="listing">{t('support.subject_listing')}</option>
                          <option value="payment">{t('support.subject_payment')}</option>
                          <option value="technical">{t('support.subject_technical')}</option>
                          <option value="report">{t('support.subject_report')}</option>
                          <option value="dealer">{t('support.subject_dealer')}</option>
                          <option value="other">{t('support.subject_other')}</option>
                        </select>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label
                        className="font-weight-bold"
                        style={{ fontSize: '0.85rem' }}
                      >
                        {t('support.message_label')}
                      </label>
                      <textarea
                        className="form-control"
                        rows={6}
                        placeholder={t('support.message_placeholder')}
                        required
                      ></textarea>
                    </div>

                    <div className="mb-3">
                      <label
                        className="font-weight-bold"
                        style={{ fontSize: '0.85rem' }}
                      >
                        {t('support.attachments')}
                      </label>
                      <input
                        type="file"
                        className="form-control-file"
                        multiple
                      />
                      <small className="form-text text-muted">
                        {t('support.attachments_note')}
                      </small>
                    </div>

                    <div className="text-center mt-4">
                      <button type="submit" className="support-submit-btn">
                        <i className="fas fa-paper-plane mr-2"></i>
                        {t('support.send_message')}
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {/* Resources Tab */}
              {activeTab === 'resources' && (
                <div className="tab-content">
                  <div className="text-center mb-5">
                    <h2 className="font-weight-bold mb-3">{t('support.resources_title')}</h2>
                    <p className="text-muted">
                      {t('support.resources_subtitle')}
                    </p>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="card resource-card">
                        <div className="card-body p-4">
                          <div className="resource-card-icon">
                            <i className="fas fa-book-open"></i>
                          </div>
                          <h5 className="resource-card-title">{t('support.user_guides')}</h5>
                          <p className="text-muted mb-3">
                            {t('support.user_guides_desc')}
                          </p>
                          <ul className="list-unstyled">
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.guide_buyer')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.guide_listings')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.guide_photos')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.guide_pricing')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card resource-card">
                        <div className="card-body p-4">
                          <div className="resource-card-icon">
                            <i className="fas fa-shield-alt"></i>
                          </div>
                          <h5 className="resource-card-title">{t('support.safety_center')}</h5>
                          <p className="text-muted mb-3">
                            {t('support.safety_desc')}
                          </p>
                          <ul className="list-unstyled">
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.safety_buyers')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.safety_sellers')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.safety_scams')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="resource-link">
                                <span>{t('support.safety_payments')}</span>
                                <i className="fas fa-arrow-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card resource-card">
                        <div className="card-body p-4">
                          <div className="resource-card-icon">
                            <i className="fas fa-briefcase"></i>
                          </div>
                          <h5 className="font-weight-bold">{t('support.dealer_resources')}</h5>
                          <p className="text-muted">
                            {t('support.dealer_resources_desc')}
                          </p>
                          <ul className="list-unstyled">
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.dealer_setup')}
                              </a>
                            </li>
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.dealer_inventory')}
                              </a>
                            </li>
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.dealer_analytics')}
                              </a>
                            </li>
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.dealer_bulk')}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card h-100 border-0 shadow-sm">
                        <div className="card-body">
                          <i className="fas fa-video fa-2x text-custom mb-3"></i>
                          <h5 className="font-weight-bold">{t('support.video_tutorials')}</h5>
                          <p className="text-muted">
                            {t('support.video_desc')}
                          </p>
                          <ul className="list-unstyled">
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.video_getting_started')}
                              </a>
                            </li>
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.video_first_listing')}
                              </a>
                            </li>
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.video_filters')}
                              </a>
                            </li>
                            <li className="mb-2">
                              <a href="#" className="text-decoration-none">
                                <i className="fas fa-chevron-right text-custom mr-2"></i>
                                {t('support.video_chat')}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Additional Resources */}
                  <div className="mt-5">
                    <h4 className="font-weight-bold mb-3">{t('support.popular_articles')}</h4>
                    <div className="list-group">
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <i className="fas fa-file-alt text-custom mr-2"></i>{' '}
                            {t('support.article_verify')}
                          </span>
                          <i className="fas fa-external-link-alt text-muted"></i>
                        </div>
                      </a>
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <i className="fas fa-file-alt text-custom mr-2"></i>{' '}
                            {t('support.article_inspection')}
                          </span>
                          <i className="fas fa-external-link-alt text-muted"></i>
                        </div>
                      </a>
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <i className="fas fa-file-alt text-custom mr-2"></i>{' '}
                            {t('support.article_negotiation')}
                          </span>
                          <i className="fas fa-external-link-alt text-muted"></i>
                        </div>
                      </a>
                      <a
                        href="#"
                        className="list-group-item list-group-item-action"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <i className="fas fa-file-alt text-custom mr-2"></i>{' '}
                            {t('support.article_test_drive')}
                          </span>
                          <i className="fas fa-external-link-alt text-muted"></i>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              )}

              {/* Still Need Help Section */}
              <div className="support-alert support-alert-info mt-5">
                <div className="text-center">
                  <h4 className="support-alert-title justify-content-center">
                    <i className="fas fa-info-circle"></i>
                    {t('support.still_need_help')}
                  </h4>
                  <p className="mb-4">
                    {t('support.still_desc')}
                  </p>
                  <div className="d-flex justify-content-center flex-wrap">
                    <a
                      href="mailto:support@autoplace.al"
                      className="btn btn-primary btn-sm m-2 px-3 py-2"
                      style={{ borderRadius: '50px', fontSize: '0.9rem' }}
                    >
                      <i className="fas fa-envelope mr-2"></i>
                      {t('support.email_support_btn')}
                    </a>
                    <button
                      className="btn btn-outline-primary btn-sm m-2 px-3 py-2"
                      style={{ borderRadius: '50px', fontSize: '0.9rem' }}
                    >
                      <i className="fas fa-comments mr-2"></i>
                      {t('support.live_chat_btn')}
                    </button>
                    <a
                      href="tel:+1-800-AUTO-PLC"
                      className="btn btn-outline-primary btn-sm m-2 px-3 py-2"
                      style={{ borderRadius: '50px', fontSize: '0.9rem' }}
                    >
                      <i className="fas fa-phone mr-2"></i>
                      {t('support.call_us')}
                    </a>
                  </div>
                </div>
              </div>

              {/* Emergency Contact */}
              <div className="support-alert support-alert-danger mt-4">
                <h5 className="support-alert-title">
                  <i className="fas fa-exclamation-triangle"></i>
                  {t('support.fraud_title')}
                </h5>
                <p className="mb-2">
                  {t('support.fraud_desc')}
                </p>
                <p className="mb-0">
                  <strong>{t('support.fraud_email_label')}</strong>{' '}
                  <a
                    href="mailto:fraud@autoplace.al"
                    style={{ color: 'inherit', textDecoration: 'underline' }}
                  >
                    fraud@autoplace.al
                  </a>{' '}
                  |<strong> {t('support.fraud_emergency')}</strong>{' '}
                  <a
                    href="tel:+1-800-FRAUD-01"
                    style={{ color: 'inherit', textDecoration: 'underline' }}
                  >
                    1-800-FRAUD-01
                  </a>{' '}
                  (24/7)
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Support;
